<template>
  <header class="site__header">
    <div class="site__inner site__inner--nav group">
      <div class="site__logo">
        <a href="https://www.wochit.com/">
          <img :src="wochitLogo" alt="Wochit" />
        </a>
      </div>
      <!-- /.site__logo -->
      <div class="nav__toggle">
        <i class="icon icon-menu-collapse"></i>
      </div>
      <!-- /.nav__toggle -->
    </div>
    <!-- /.site__inner -->
    <div class="nav__container">
      <div class="site__inner">
        <nav class="nav__primary" role="primary-navigation">
          <ul id="menu-main-navigation" class="nav__primary__menu group">
            <li
              id="nav-menu-item-28"
              class="nav__primary__menu__item main-menu-item menu-item-even menu-item-depth-0 link--contact menu-item menu-item-type-post_type menu-item-object-page"
            >
              <a
                href="https://www.wochit.com/contact/"
                class="menu-link main-menu-link"
              >
                <span>Contact us</span>
              </a>
            </li>
          </ul>
        </nav>
        <!-- /.nav__primary -->
      </div>
      <!-- /.site__inner -->
    </div>
    <!-- /.nav__container -->
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: Object.assign(mapGetters(['wochitLogo'])),
};
</script>
